import Router from '../utils/router';
import Loader from './modules/loader';
import FormView from './views/form-view';

export default class ServicePlan {
    constructor(el) {
        this.router = new Router();
        this.el = el;
        this.loader = new Loader(this, this.router);
        this.form = new FormView(this, this.router);
        this.setup();
    }

    setup() {
        this.router
            .add('vin_lookup', () => {
                this.loader.hide();
                this.form.show();
            })
            .else(() => {
                this.router.update('vin_lookup');
            })
            .match();
    }
}
